import { useEffect } from 'react'

import { cdnUrl } from '../../utils/httpRequest'

export const useLoadDepthChartLibraryEffect = () => {
  useEffect(() => {
    if (window.VisualDepth) return
    const depthScript = document.createElement('script')
    depthScript.type = 'text/javascript'
    depthScript.async = true
    depthScript.src = `${cdnUrl}/static/chart/chart-bundle.min.js`
    depthScript.onload = () => {
      console.log('depth library load success')
    }
    document.getElementsByTagName('head')[0].appendChild(depthScript)
  }, [])
}
